const LOGIN_PATH = '/login';
const LOGIN_SSO_PATH = '/loginsso';
const FORGOT_PASSWORD_PATH = '/forgot-pass';
const RECOVER_PASSWORD_PATH = '/recover-pass';
const ACCOUNT_PATH = '/account';
const ACCOUNT_PATH_ADD = `${ACCOUNT_PATH}/add`;
const ACCOUNT_PATH_EDIT = `${ACCOUNT_PATH}/edit`;
const LOGIN_HISTORY_PATH = '/login-history';
const STATISTIC_HISTORY_PATH = '/statistic-login-history';

const EMAILCONFIG_PATH = '/emailconfig';
const EMAILCONFIG_CREATE_PATH = '/emailconfig/create';
const EMAILCONFIG_EDIT_PATH = '/emailconfig/edit';

const LOG_PATH = '/log';

const REPORT_POST_PATH = '/report-post';
const REPORT_POST_SYNTHETIC_PATH = '/report-post-synthentic';
const REPORT_POST_EXCEL_PATH = '/report-post-excel';
const REPORT_POST_EXCEL_QUANTITY_CREATE_BY =
    '/report-post-excel-quantity-createby';
const REPORT_POST_EXCEL_CREATE_BY = '/report-post-excel-createby';

const REPORT_POST_WEBANALYSIS_PATH = '/report-post-web-analysis';
const REPORT_POST_BY_DATETYPE = '/report-post-by-datetype';
const REPORT_POST_VIEW_DETAIL = '/report-post-view-detail';
const REPORT_POST_PUBLISHTIME_DATATYPE_PATH =
    '/report-post-publish-time-data-type';
const REPORT_ADVERTISING_ANALYSIS_PATH = '/advertising-analysis';
const REPORT_COUNT_VISIT_DETAIL = '/report-count-visit-detail';

const DONVIDENGHI_PATH = '/don-vi-de-nghi';
const DONVIDENGHI_CREATE_PATH = `${DONVIDENGHI_PATH}/them`;
const DONVIDENGHI_EDIT_PATH = `${DONVIDENGHI_PATH}/sua`;

const APIROLEMAPPING_PATH = '/api-role-mapping';
const APIROLEMAPPING_CREATE_PATH = `${APIROLEMAPPING_PATH}/them`;
const APIROLEMAPPING_EDIT_PATH = `${APIROLEMAPPING_PATH}/sua`;

const OPENIDDICTAPPLICATION_PATH = '/ung-dung-dang-ky';
const OPENIDDICTAPPLICATION_CREATE_PATH = `${OPENIDDICTAPPLICATION_PATH}/them`;
const OPENIDDICTAPPLICATION_EDIT_PATH = `${OPENIDDICTAPPLICATION_PATH}/sua`;

const MENUITEM_PATH = '/menu';
const MENUITEM_CREATE_PATH = `${MENUITEM_PATH}/them`;
const MENUITEM_EDIT_PATH = `${MENUITEM_PATH}/sua`;

const BAOCAO_PATH = '/bao-cao';

const ROLE_ACCOUNT_PATH = '/role-account';
const ROLE_ACCOUNT_CREATE_PATH = '/role-account/create';
const ROLE_ACCOUNT_EDIT_PATH = '/role-account/edit';

const DEPARTMENT_PATH = '/don-vi';
const DEPARTMENT_CREATE_PATH = `${DEPARTMENT_PATH}/them`;
const DEPARTMENT_EDIT_PATH = `${DEPARTMENT_PATH}/sua`;

const MATERIALCATALOG_PATH = '/material-catalog';
const MATERIALCATALOG_CREATE_PATH = `${MATERIALCATALOG_PATH}/them`;
const MATERIALCATALOG_EDIT_PATH = `${MATERIALCATALOG_PATH}/sua`;


const ASSETTRANSFER_LIST_PATH = '/asset-transfer-list';
// const ASSETTRANSFER_CREATE_PATH = `${ASSETTRANSFER_PATH}/them`;
// const ASSETTRANSFER_EDIT_PATH = `${ASSETTRANSFER_PATH}/sua`;

const ASSETSTATUS_PATH = '/asset-status';
const ASSETSTATUS_CREATE_PATH = `${ASSETSTATUS_PATH}/them`;
const ASSETSTATUS_EDIT_PATH = `${ASSETSTATUS_PATH}/sua`;

const ASSETGROUP_PATH = '/asset-group';
const ASSETGROUP_CREATE_PATH = `${ASSETGROUP_PATH}/them`;
const ASSETGROUP_EDIT_PATH = `${ASSETGROUP_PATH}/sua`;

const ASSET_PATH = '/asset';
const ASSET_CREATE_PATH = `${ASSET_PATH}/them`;
const ASSET_EDIT_PATH = `${ASSET_PATH}/sua`;
const ASSET_TRANSFER_PATH = `${ASSET_PATH}/transfer`;
const ASSET_PUBLIC_DETAIL_PATH = '/public/asset/:id';

const MAINTENANCE_PLAN_PATH = '/ke-hoach-bao-tri';
const MAINTENANCE_PLAN_CREATE_PATH = `${MAINTENANCE_PLAN_PATH}/them`;
const MAINTENANCE_PLAN_EDIT_PATH = `${MAINTENANCE_PLAN_PATH}/sua`;

const MAINTENANCE_BATCH_PATH = '/phieu-sua-chua';
const MAINTENANCE_BATCH_CREATE_PATH = `${MAINTENANCE_BATCH_PATH}/them`;
const MAINTENANCE_BATCH_DETAIL_PATH = `${MAINTENANCE_BATCH_PATH}/chi-tiet/:id`;

export const URI_INTERNAL = {
    REPORT_ADVERTISING_ANALYSIS_PATH,
    REPORT_POST_VIEW_DETAIL,
    REPORT_POST_BY_DATETYPE,
    REPORT_POST_EXCEL_CREATE_BY,
    REPORT_POST_EXCEL_QUANTITY_CREATE_BY,
    REPORT_POST_SYNTHETIC_PATH,
    REPORT_POST_PATH,
    RECOVER_PASSWORD_PATH,
    FORGOT_PASSWORD_PATH,
    ACCOUNT_PATH_EDIT,
    ACCOUNT_PATH_ADD,
    LOGIN_PATH,
    LOGIN_SSO_PATH,
    ACCOUNT_PATH,
    LOGIN_HISTORY_PATH,
    EMAILCONFIG_PATH,
    EMAILCONFIG_CREATE_PATH,
    EMAILCONFIG_EDIT_PATH,
    STATISTIC_HISTORY_PATH,
    LOG_PATH,
    REPORT_POST_EXCEL_PATH,
    REPORT_POST_WEBANALYSIS_PATH,
    REPORT_POST_PUBLISHTIME_DATATYPE_PATH,
    REPORT_COUNT_VISIT_DETAIL,

    DONVIDENGHI_PATH,
    DONVIDENGHI_CREATE_PATH,
    DONVIDENGHI_EDIT_PATH,

    APIROLEMAPPING_PATH,
    APIROLEMAPPING_CREATE_PATH,
    APIROLEMAPPING_EDIT_PATH,

    OPENIDDICTAPPLICATION_PATH,
    OPENIDDICTAPPLICATION_CREATE_PATH,
    OPENIDDICTAPPLICATION_EDIT_PATH,

    MENUITEM_PATH,
    MENUITEM_CREATE_PATH,
    MENUITEM_EDIT_PATH,

    ROLE_ACCOUNT_PATH,
    ROLE_ACCOUNT_CREATE_PATH,
    ROLE_ACCOUNT_EDIT_PATH,

    BAOCAO_PATH,

    DEPARTMENT_PATH,
    DEPARTMENT_CREATE_PATH,
    DEPARTMENT_EDIT_PATH,

    MATERIALCATALOG_PATH,
    MATERIALCATALOG_CREATE_PATH,
    MATERIALCATALOG_EDIT_PATH,

    ASSETTRANSFER_LIST_PATH,
    // ASSETTRANSFER_CREATE_PATH,
    // ASSETTRANSFER_EDIT_PATH,
    
    ASSETSTATUS_PATH,
    ASSETSTATUS_CREATE_PATH,
    ASSETSTATUS_EDIT_PATH,

    ASSETGROUP_PATH,
    ASSETGROUP_CREATE_PATH,
    ASSETGROUP_EDIT_PATH,

    ASSET_PATH,
    ASSET_CREATE_PATH,
    ASSET_EDIT_PATH,
    MAINTENANCE_PLAN_PATH,
    MAINTENANCE_PLAN_CREATE_PATH,
    MAINTENANCE_PLAN_EDIT_PATH,

    MAINTENANCE_BATCH_PATH,
    MAINTENANCE_BATCH_CREATE_PATH,
    MAINTENANCE_BATCH_DETAIL_PATH,
    
    ASSET_TRANSFER_PATH,
    ASSET_PUBLIC_DETAIL_PATH
};
